// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2_XpY","choiceBoxes":"toolbarselects_choiceBoxes__3BF-J","simpleField":"toolbarselects_simpleField__25xD2"};